import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_SYSADMIN = [
  {
    module: 'USER',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'email'
      },
      {
        active: true,
        removable: true,
        field: 'settings.info_app_version'
      }
    ]
  },
  {
    module: 'SUPORTE_USER',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'email'
      },
      {
        active: true,
        removable: true,
        field: 'settings.info_app_name'
      },
      {
        active: true,
        removable: true,
        field: 'settings.info_app_version'
      },
      {
        active: true,
        removable: true,
        field: 'settings.info_android_version'
      }
    ]
  },
  {
    module: 'APPLICATION',
    colunas: [
      {
        field: 'name',
        active: true,
        removable: false
      },
      {
        field: 'customized',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'ROUTE',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'url'
      },
      {
        active: true,
        removable: true,
        field: 'method'
      },
      {
        active: true,
        removable: true,
        field: 'sysadmin'
      },
      {
        active: true,
        removable: true,
        field: 'bypass'
      },
      {
        active: true,
        removable: true,
        field: 'projeto'
      }
    ]
  },
  {
    module: 'ROLE',
    colunas: [
      {
        field: 'name',
        active: true,
        removable: false
      }
    ]
  },
  {
    module: 'DOMAIN',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'application.name'
      },
      {
        active: true,
        removable: true,
        field: 'settings.informacao_integracao.versao_sistema_integrado'
      },
      {
        active: true,
        removable: true,
        field: 'settings.informacao_integracao.versao_integracao'
      }
    ]
  },
  {
    module: 'FUNCTIONALITY',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'code'
      },
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'description'
      }
    ]
  },
  {
    module: 'MODULES',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'code'
      },
      {
        active: true,
        removable: false,
        field: 'name'
      },
      {
        active: true,
        removable: true,
        field: 'description'
      }
    ]
  }
] as IColunasSettingsUser[];
